import { CONFIG } from "../config";

// Config/calibration store. Persists the one-time horizontal scale + offset and
// the chosen MIDI device between sessions.

/** 1D horizontal registration: white-key width (scale) + pixel offset. */
export interface Calibration {
  whiteWidthPx: number;
  offsetPx: number;
}

const CAL_KEY = "drop-notes.calibration";
const DEVICE_KEY = "drop-notes.deviceId";

export function loadCalibration(): Calibration {
  try {
    const raw = localStorage.getItem(CAL_KEY);
    if (raw) {
      const parsed = JSON.parse(raw) as Partial<Calibration>;
      const w = parsed.whiteWidthPx;
      const o = parsed.offsetPx;
      // Require a positive finite width and finite offset — a 0/NaN width makes
      // buildKeyboard produce infinite/garbled key geometry.
      if (
        typeof w === "number" &&
        w > 0 &&
        Number.isFinite(w) &&
        typeof o === "number" &&
        Number.isFinite(o)
      ) {
        return { whiteWidthPx: w, offsetPx: o };
      }
    }
  } catch {
    // ignore corrupt/blocked storage — fall through to defaults
  }
  return { whiteWidthPx: CONFIG.defaultWhiteWidthPx, offsetPx: 0 };
}

export function saveCalibration(cal: Calibration): void {
  try {
    localStorage.setItem(CAL_KEY, JSON.stringify(cal));
  } catch {
    // ignore — calibration simply won't persist
  }
}

export function loadDeviceId(): string | null {
  try {
    return localStorage.getItem(DEVICE_KEY);
  } catch {
    return null;
  }
}

export function saveDeviceId(id: string): void {
  try {
    localStorage.setItem(DEVICE_KEY, id);
  } catch {
    // ignore
  }
}
